import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/work-orders/_list/")({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
